<app-main-menu></app-main-menu>
<div style="margin-top: 12vh;" class="container-fluid">
    <div class="mb-5 text-center">
        <h1>Elige tu membresia y empieza a cuidar tu salud.</h1>
        <h1>¿Qué esperas para sentirte saludable?</h1>
    </div>
    <div class="m-1 mt-5 row justify-content-around">
        <div class="mr-2 col-lg-4">
            <p style="font-size: 1.5em; font-weight: 600;">Selecciona un plan y empieza a hablar con profesionales de la salud</p>
            <p class="mt-5">Múltiples medios de pago</p>
            <p style="font-size: 1.5em;"><i class="fab fa-paypal mr-2"></i><i class="mr-2 fab fa-cc-mastercard"></i><i class="fab fa-bitcoin"></i></p>
        </div>
        <div class="mx-2 card col-lg-3 rounded">
            <div class="card-body">
                <h4 style="font-weight: 600;" class="card-title">Básico</h4>
                <p style="font-size: 1.2em;" class="mt-1 card-text "><span style="font-weight: 600;">$</span>20 al mes</p>
                <ul>
                    <li>30 consultas mensuales</li>
                    <li>Soporte</li>
                    <li>Acceso a informes medicos</li>
                </ul>
                <div class="text-center">
                    <button class="uppercase btn btn-info">
                        Comprar
                    </button>
                </div>
            </div>
        </div>
        <div class="ml-2 card col-lg-3 rounded">
            <div class="card-body">
                <h4 style="font-weight: 600;" class="card-title">Completo</h4>
                <p style="font-size: 1.2em;" class="mt-1 card-text "><span style="font-weight: 600;">$</span>30 al mes</p>
                <ul>
                    <li>60 consultas mensuales</li>
                    <li>Soporte</li>
                    <li>Acceso a informes medicos</li>
                </ul>
                <div class="text-center">
                    <button class="uppercase btn btn-info">
                        Comprar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>